import script from "./DashboardsViewForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardsViewForm.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardsViewForm.vue?vue&type=style&index=0&id=a66572ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a66572ee"]])

export default __exports__